import { Button, Table, Tag, Tooltip } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import {
  SHIFT_TYPE_DISPLAY_MAP,
  TIME_SHEET_APPROVED_ACTION,
  TIME_SHEET_PENDING_ACTION,
  TIME_SHEET_REJECTED_ACTION,
} from "../../TimeSheetConstants";
import {
  convertMsToHoursMinutes,
  toReadableTime,
  formatDate,
  formatDateWithDay,
  isNull,
  getOvertimeFromMs,
} from "../../../../shared/helpers";
import VectorIcon from "../../../../assets/icons/Vector.svg";
import { UpdateTimeModal } from "../UpdateTimeModal/UpdateTimeModal";
import { TimesheetActionButtonCol } from "../TimesheetActionButtonCol/TimesheetActionButtonCol";
import { useDispatch, useSelector } from "react-redux";
import { getTimeSheetList } from "../../../../redux/actions";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import moment from "moment";
import { useWindowDimensions } from "../../../../hooks/useDimensionHook";

const TimesheetTable = ({
  handleApproveRejectClick,
  handleOpenTimeModal,
  page,
  handlePageChange,
}) => {
  const { width } = useWindowDimensions();
  const timesheetData = useSelector(
    (state) => state.TimesheetListReducer.data?.data
  );
  const data = useSelector((state) => state.TimesheetListReducer.data);

  const columns = [
    {
      title: "Date",
      key: "date",
      render: (_, data) => {
        const record = data?.entry;
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Tag color="default">
              {SHIFT_TYPE_DISPLAY_MAP?.[record?.shiftType] || "N/A"}
            </Tag>
            {data.date ? formatDateWithDay(data.date) : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Clock-in -- Check Out",
      key: "clock",
      width: "22%",
      editable: true,
      render: (_, data) => {
        const record = data?.entry;
        const isPending = record.status == TIME_SHEET_PENDING_ACTION;
        return (
          <span
            style={{ cursor: isPending ? "pointer" : "not-allowed" }}
            onClick={() => (isPending ? handleOpenTimeModal(record) : null)}
          >
            {record?.clockIn?.raw
              ? toReadableTime(record?.clockIn?.raw)
              : "N/A"}{" "}
            --{" "}
            {record?.clockOut?.raw
              ? toReadableTime(record?.clockOut?.raw)
              : "N/A"}
          </span>
        );
      },
    },
    {
      title: "Work Hrs",
      key: "workHrs",
      width: "15%",
      render: (_, data) => {
        const record = data?.entry;
        return convertMsToHoursMinutes(record?.totalWorkedMs);
      },
    },
    {
      title: "Overtime",
      key: "overtime",
      width: "15%",
      render: (_, data) => {
        const record = data?.entry;
        return record?.shift?.WorkHours?.Period == "daily"
          ? record?.overtimeReadable || "N/A"
          : "N/A";
      },
    },
    {
      title: "Action",
      key: "action",
      width: width < 900 ? "25%" : "20%",
      render: (_, data) => {
        const record = data?.entry;
        const isDisable = isNull(record?.clockOut?.raw);
        return (
          <TimesheetActionButtonCol
            disable={isDisable}
            status={record?.status}
            handleApprove={() => handleApproveRejectClick(record)}
            handleReject={() => handleApproveRejectClick(record)}
          />
        );
      },
    },
    {
      title: "Reason",
      key: "reason",
      width: "10%",
      render: (_, data) => {
        const record = data?.entry;
        const title =
          record?.status == "approved" ? (
            <>
              Approved (on {formatDateWithDay(record?.actionDate)}) by
              <br />
              {record?.actionBy}
            </>
          ) : (
            <>
              Rejected (on {formatDateWithDay(record?.actionDate)}) by
              <br />
              {record?.actionBy}:
              <br />
              {record?.rejectionReason}
            </>
          );

        return record?.status == "pending" ? null : (
          <Tooltip title={title}>
            <img src={VectorIcon} alt="?-icon" />
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Fragment>
      <Table
        dataSource={timesheetData}
        columns={columns}
        pagination={{
          current: page,
          pageSize: 10,
          total: data?.pagination?.total,
          position: ["bottomCenter"],
        }}
        onChange={(pagination) => {
          handlePageChange(pagination.current);
        }}
      />
    </Fragment>
  );
};

export { TimesheetTable };
